<div class="welcome-screen">
    <div>
        <img src="/images/gnvert-style/logo-engie-white.svg" alt="">
    </div>
    <div class="welcome-title">{{ 'home.gnvert.welcome' | translate }}</div>
    <div class="welcome-text">{{ 'home.gnvert.welcomeText' | translate }}</div>
    <div class="welcome-text" style="font-weight: bold;">{{VERSION}}</div>
</div>
